<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">中创
      <small>header small text goes here...</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-left:0px;padding-right:0px;padding-top: 0px"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title">老板列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <button type="button" class="btn btn-primary" style="float:right;margin-bottom:15px;">新增老板</button>
                <el-table :data="BossList" border style="width: 100%">
                  <el-table-column prop="id" label="门店编号"  align="center"></el-table-column>
                  <el-table-column prop="name" label="老板名称" align="center"></el-table-column>
                  <el-table-column prop="smallname" label="老板编号" align="center"></el-table-column>
                  <el-table-column prop="location" label="老板性别"  align="center"></el-table-column>
                  <el-table-column prop="sheng" label="省" align="center"></el-table-column>
                  <el-table-column prop="shi" label="市" align="center"></el-table-column>
                  <el-table-column prop="qv" label="区" align="center"></el-table-column>
                  <el-table-column prop="address" label="详细地址" header-align="center" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="time" label="银行卡号" align="center"></el-table-column>
                  <el-table-column prop="time" label="提交时间" align="center"></el-table-column>
                  <el-table-column label="操作" width="180">
                    <template>
                       <a href="#modal-dialog" class="btn btn-primary btn-sm" data-toggle="modal">编辑</a>
                        <a href="#modal-dialog" class="btn btn-primary btn-sm" data-toggle="modal">删除</a>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="float:right;margin-top:8px;">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="1"
                  ></el-pagination>
                </div>
                <div class="clear"></div>
              
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <!-- #modal-dialog -->
    <div class="modal fade" id="modal-dialog">
      <div class="modal-dialog">
        <div class="modal-content">
           <div class="swal-icon swal-icon--info">
		   </div>
		   <div class="swal-title">您确定吗?</div>
		   <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
		   <div class="swal-footer">
			   <div class="swal-button-container">
				   <div class="swal-button swal-button--cancel btn btn-default" data-dismiss="modal">取消</div>
				</div>
			   <div class="swal-button-container">
				   <div class="swal-button swal-button--confirm btn btn-primary" data-dismiss="modal">确定</div>
			   </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "OwnerList",
  data() {
    return {
      currentPage:1,
      BossList:[{id:"zc002",name:"潘鑫",smallname:'88026',address:'帝都',sex:'女'}]
    };
  },
  mounted: function() {
  
     FormPlugins.init();
     
  },
  methods: {
	    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear{
  clear:both;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreManage/OwnerList.vue